import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { ColumnElement, ColumnProps, FlexProps } from "../types";
import Flex from "./flex-root";

function FlexColumn<E extends React.ElementType = ColumnElement>({
  as,
  asChild = false,
  reverse = false,
  justify = "start",
  items = "start",
  className,
  ...props
}: ColumnProps<E>) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  if (process.env.NODE_ENV !== "production" && as && asChild) {
    console.warn(
      `[Flex.Column] 'asChild' renders the child element; 'as' is ignored.`,
    );
  }

  return (
    <Flex
      as={as}
      asChild={asChild}
      direction={reverse ? "column-reverse" : "column"}
      justify={justify}
      items={items}
      className={cn(className, classes)}
      {...(native as FlexProps<E>)}
    />
  );
}

FlexColumn.displayName = "Flex.Column";

export default FlexColumn;
